import {
  FormControl,
  FormControlProps,
  FormLabel,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';
import { EUserRole } from '@/graphql-types/globalTypes';
import { READABLE_USER_ROLE } from '@/utilities';

export const Role: React.FC<
  {
    value: EUserRole[];
    onChange: (value: EUserRole[]) => void;
  } & Omit<FormControlProps, 'value' | 'onChange'>
> = ({ value, onChange, ...props }) => (
  <FormControl {...props}>
    <FormLabel textStyle="detailStrong">Role</FormLabel>
    <Menu closeOnSelect={false}>
      <MenuButton as={SelectButton} variant="menu">
        {value.length === 0
          ? 'All'
          : value.length === 1
          ? READABLE_USER_ROLE[value[0]]
          : `(${value.length}) Selected`}
      </MenuButton>
      <MenuList>
        <MenuOptionGroup type="checkbox" value={value} onChange={onChange}>
          {Object.keys(READABLE_USER_ROLE)
            .filter((role: EUserRole) => role !== EUserRole.MORGOTH)
            .map((role: EUserRole) => (
              <MenuItemOption key={role} value={role}>
                {READABLE_USER_ROLE[role]}
              </MenuItemOption>
            ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  </FormControl>
);
